import { API_BASE_URL } from '../config/serverApiConfig';
import { api } from './api';

const base = `${API_BASE_URL}r/v2/me`;

export const getFavourites = async (): Promise<number[]> => {
  const response = await api().get(`${base}/favourites`);
  return response.data?.node_ids ?? [];
};

export const addFavourite = async (id: number): Promise<void> => {
  await api().put(`${base}/favourites/${id}`);
};

export const removeFavourite = async (id: number): Promise<void> => {
  await api().delete(`${base}/favourites/${id}`);
};

export const setHome = async (id: number): Promise<void> => {
  await api().put(`${base}/home/${id}`);
};

export const clearHome = async (): Promise<void> => {
  await api().delete(`${base}/home`);
};

const preferencesService = {
  getFavourites, 
  addFavourite, 
  removeFavourite, 
  setHome, 
  clearHome
};

export default preferencesService;
